<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Delivered to Erbil Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            send_to_customer: 'send_to_customer',
            add_shipping_invoice: 'add_shipping_invoice',
            generate_qr_code: 'branch_delivered_order_generate_qrcode',
            add_delivery_invoice: 'add_delivery_invoice',
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addSendToUserButton="true"
          :openSendToUserModal="openSendToUserModal"
          :addSendAllToUserButton="true"
          :sendAllToUser="sendAllToUser"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addPrepareToPrintButton="true"
          :prepareToPrint="prepareToPrint"
          :addQrCodeGenerateButton="true"
          :openGenerateQrCodeModal="openGenerateQrCodeModal"
          :addOrderInvoiceButton="true"
          :openOrderInvoiceModal="openOrderInvoiceModal"
          :addDeliveryInvoiceButton="true"
          :openDeliveryInvoiceModal="openDeliveryInvoiceModal"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity: 0"
            ></span>
          </div>

          <v-layout
            wrap
            style="margin: 0px"
          >
            <v-flex
              xs12
              sm8
              md5
            >
              <v-select
                style="width: 100%"
                autocomplete
                :items="customersList"
                v-model="generateInvoiceData.customer_id"
                label="Customer"
                single-line
                clearable
              />
            </v-flex>

            <v-flex
              xs12
              sm4
              md5
              style="padding-top: 15px"
            >
              <v-btn
                :disabled="!generateInvoiceData.customer_id"
                style="height: auto; padding: 4px; margin-left: 15px"
                @click="generateInvoiceCustomer(generateInvoiceData.customer_id)"
                depressed
                color="primary"
                small
              >
                Generate Invoice
              </v-btn>
            </v-flex>
          </v-layout>

          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="
                  qrCodeValues.find((x) => x[0] == r.order_id)
                    ? 'background-color: #FFF9C4'
                    : ((r.item_weight === 0 || r.item_weight == null) || (Number(r.is_ship_only) === 1)) && !r.order_invoice_id_fk
                    ? 'background-color: #ee7272'
                    : ''
                "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[
                      r.order_id,
                      r.full_name,
                      r.phone_number,
                      r.user_id,
                      r.theOrderID,
                      r.is_ship_only,
                      r.credit,
                      r.product_name,
                      r.warehouse_id_fk,
                      r.transportation_type,
                      r.is_ship_only,
                    ]"
                    v-model="qrCodeValues"
                  />
                  <!-- r.deliver_branch_name,
                      r.deliver_branch_id_fk, -->
                </td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-users :orderData="r" />
                </td>
                <td>
                  <i
                    v-if="r.qrcode"
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i>{{ r.order_id }}
                </td>
                <td>{{ r.theOrderID }}</td>
                <td>
                  <span v-if="r.is_ship_only == 1" class="ship-only-label">Ship Only</span>
                </td>
                <td class="ws-nowrap">
                                    <i v-if="r.fcm_token" class="material-icons customer-device-icon">smartphone</i>
                  <i v-else class="material-icons customer-device-icon">language</i>
                  <img v-if="r.profile_image" :src="`${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                </td>
                <td>{{
                  r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : '')
                }}</td>
                <td>{{ r.quantity }}</td>
                <td>{{ r.country }}</td>
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '' }}</td>
                <td>{{ r.purchase_note }}</td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td>{{ r.bank_name }}</td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  style="padding-left: 10px; padding-right: 5px"
                >
                  <a
                    style="color: #01579b"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('send_to_customer')"
                  style="padding-left: 0px; padding-right: 10px"
                >
                  <a
                    style="color: #ffb300"
                    tooltip="Send to customer"
                    @click="deliverToUser(r)"
                  >
                    <i class="material-icons">local_taxi</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('return_branch_delivered_order_to_purchased_order')"
                  style="padding-left: 0px; padding-right: 10px"
                >
                  <a
                    style="color: #eb8545"
                    tooltip="Return to purchase"
                    @click="returnToPurchase(r.order_id)"
                  >
                    <i class="material-icons">settings_backup_restore</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  > No Results Found </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            :isPurchase="true"
            :isOrder="true"
            v-if="isMobile"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="
                  qrCodeValues.find((x) => x[0] == r.order_id)
                    ? 'background-color: #FFF9C4'
                    : ((r.item_weight === 0 || r.item_weight == null) || (Number(r.is_ship_only) === 1)) && !r.order_invoice_id_fk
                    ? 'background-color: #ee7272'
                    : ''
                "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[
                      r.order_id,
                      r.full_name,
                      r.phone_number,
                      r.user_id,
                      r.theOrderID,
                      r.credit,
                    ]"
                    v-model="qrCodeValues"
                  />
                </td>
                <td>
                  <i
                    v-if="r.qrcode"
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i> {{ r.order_id }} ,
                  <br />
                  {{ r.theOrderID }} , <br />
                  {{ r.is_ship_only }} , <br />
                  {{
                    r.product_name.substr(0, 35) +
                      (r.product_name.length > 35 ? '...' : '')
                  }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                  <br />
                  {{ r.country }} ,
                  <br />
                  PurchaseNote: {{ r.purchase_note }}
                  <br />
                  Quantity: {{ r.quantity }}
                </td>
                <td>
                  Customer name: {{ r.full_name }} , <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span> <br />
                  Confirm date: {{ r.confirm_date }} , <br />
                  <a
                    v-if="$_has_perm('view_order_detail')"
                    style="color: #01579b; display: inline-block; padding-right: 3px"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <span
                    v-if="$_has_perm('send_to_customer')"
                    style="padding-left: 0px; padding-right: 5px; float: left"
                  >
                    <a
                      style="color: #ffb300"
                      tooltip="Send to customer"
                      @click="deliverToUser(r)"
                    >
                      <i class="material-icons">local_taxi</i>
                    </a>
                  </span>
                  <span
                    v-if="$_has_perm('return_branch_delivered_order_to_purchased_order')"
                    style="padding-left: 0px; padding-right: 5px; float: left"
                  >
                    <a
                      style="color: #eb8545"
                      tooltip="Return to purchase"
                      @click="returnToPurchase(r.order_id)"
                    >
                      <i class="material-icons">settings_backup_restore</i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  > No Results Found </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <create-qr-code
            :openGenerateQrCodeModal="openGenerateQrCodeModal"
            :generateQrCodeModal="generateQrCodeModal"
            :closeGenerateQrCodeModal="closeGenerateQrCodeModal"
            :qrCodeValues="qrCodeValues"
            :generateQrCode="generateQrCode"
            :getResults="getResults"
          >
          </create-qr-code>

          <send-to-user
            :closeSendToUserModal="closeSendToUserModal"
            :sendToUserModal="sendToUserModal"
            :sendToUserData="sendToUserData"
            :sendToUser="sendToUser"
          >
          </send-to-user>

          <prepare-to-print
            :closeModal="closeModal"
            :printData="printData"
          ></prepare-to-print>

          <add-order-invoice
            :formData="generateInvoiceData"
            :orderInvoiceModal="orderInvoiceModal"
            @close="orderInvoiceModal = false, qrCodeValues = []"
            @invoice-created="getResults()"
          />

          <add-delivery-invoice
            :formData="deliveryInvoiceData"
            :deliveryInvoiceModal="deliveryInvoiceModal"
            @close="deliveryInvoiceModal = false"
            @invoice-created="viewDeliveryInvoice"
          />

          <view-customer-delivery-invoice
            :viewDeliveryInvoiceModal="viewDeliveryInvoiceModal"
            :invoiceData="invoiceData"
            :companyData="companyData"
            @close="viewDeliveryInvoiceModal = false"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import sendToUser from './sendToUser.vue'
import prepareToPrint from './prepareToPrint'
import axios from 'axios'
import swal from 'sweetalert'
import mobileDatatable from './mobileDatatable'
import createQrCode from './createQrCode.vue'
import AddOrderInvoice from '../components/orderInvoice/AddOrderInvoice.vue'
import AddDeliveryInvoice from '../components/deliveryInvoice/AddDeliveryInvoice.vue'
import ViewCustomerDeliveryInvoice from './deliveryInvoice/ViewCustomerDeliveryInvoice.vue'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'send-to-user': sendToUser,
    'prepare-to-print': prepareToPrint,
    'mobile-datatable': mobileDatatable,
    'create-qr-code': createQrCode,
    AddOrderInvoice,
    AddDeliveryInvoice,
    ViewCustomerDeliveryInvoice
  },
  mounted() {
    this.perPageFix()
    this.getCustomer()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check Box', value: '1' },
      {
        label: 'User',
        text: 'User',
        value: '2',
        sortable: false,
        searchable: false,
        name: 'user'
      },
      {
        label: 'Qr ID',
        text: 'Qr ID',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'order_id',
      },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'theOrderID',
      },
      {
        label: 'Shiponly',
        text: 'Shiponly',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'is_ship_only',
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'full_name',
      },
      {
        label: 'Customer Note',
        text: 'Customer Note',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'customer_note',
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'product_url',
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'product_name',
      },
      {
        label: 'Qty',
        text: 'Qty',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'quantity',
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'country',
      },
      {
        label: 'Type',
        text: 'Type',
        value: '12',
        sortable: true,
        searchable: true,
        name: 'transportation_type_obj',
      },
      {
        label: 'Purchase Note',
        text: 'Purchase Note',
        value: '13',
        sortable: true,
        searchable: true,
        name: 'purchase_note',
      },
      {
        label: 'Order Note',
        text: 'Order Note',
        value: '14',
        sortable: true,
        searchable: true,
        name: 'note',
      },
      {
        label: 'Date',
        text: 'Date',
        value: '15',
        sortable: true,
        searchable: true,
        name: 'branch_delivery_date',
      },
      {
        label: 'Bank',
        text: 'Bank',
        value: '16',
        sortable: true,
        searchable: true,
        name: 'bank_name',
      },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      url: 'api/branch_delivery_order',
      archiveOrderUrl: 'api/user_delivering',
      orderDetailUrl: 'api/show_order_detail',
      returnToPurchaseUrl: 'api/orders/',
      prepareToPrintUrl: 'api/prepare_to_print',
      getCustomerPrice: 'api/subscriptions/customer-price',
      sendToUserModal: false,
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      customersList: [],
      orderInvoiceModal: false,
      generateInvoiceData: {},
      deliveryInvoiceData: {},
      deliveryInvoiceModal: false,
      companyData: {},
      invoiceData: {},
      viewDeliveryInvoiceModal: false,
      generateQrCodeModal: false,
      qrCodeValues: [],
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      sendToUserData: {
        order_id: '',
      },
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      orderID: {
        orders_id: [],
      },
      printData: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: '',
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: '',
      },
    }
  },
  methods: {
    getCompanyData(token) {
      axios
        .get('api/company_info', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.companyData = response.data.data
        })
    },

    viewDeliveryInvoice(data) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)

      axios
        .get(`api/delivery_invoice/${data.delivery_invoice_id}`, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((res) => {
          this.viewDeliveryInvoiceModal = true
          this.invoiceData = res.data
        })
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/get-customer-to-select', {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          this.customersList = []
          let result = response.data.data

          result.forEach((c) => {
            this.customersList.push({
              text: c.full_name + ' - Tel: ' + c.phone_number,
              value: c.user_id,
              phone: c.phone_number,
            })
          })
        })
    },

    checkDiff(arr) {
      return arr.length !== 0 && new Set(arr).size !== 1
    },

    openDeliveryInvoiceModal() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: 'Please at least select one order or customer!',
          icon: 'warning',
          dangerMode: true,
        })

        return
      }

      let customerIds = []
      let ordersArr = []
      this.qrCodeValues.forEach((x, i) => {
        let obj = {
          order_id: null,
          customer_name: null,
          phone_number: null,
          customer_credit: null,
          customer_id: null,
          the_order_id: null
        }
        x.forEach((y, j) => {
          if (j === 0) {
            obj.order_id = y
          } else if (j === 1) {
            obj.customer_name = y
          } else if (j === 2) {
            obj.phone_number = y
          } else if (j === 3) {
            customerIds.push(y)
            obj.customer_id = y
          } else if (j === 4) {
            obj.the_order_id = y
          } else if (j === 8) {
            obj.customer_credit = Number(y)
          }
        })
        ordersArr.push(obj)
      })

      if (this.checkDiff(customerIds)) {
        swal({
          text: 'You selected different customers',
          icon: 'warning',
          dangerMode: true,
        })

        return
      }

      this.deliveryInvoiceData = {
        customer_id_fk: ordersArr[0].customer_id,
        customer_name: ordersArr[0].customer_name,
        phone_number: ordersArr[0].phone_number,
        customer_credit: ordersArr[0].customer_credit,
        orders: ordersArr,
        orders_id: ordersArr.map((order) => order.order_id),
      }

      this.deliveryInvoiceModal = true
    },

    openOrderInvoiceModal() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: 'Please at least select one order or customer!',
          icon: 'warning',
          dangerMode: true,
        })

        return
      }

      let customerIds = []
      let ordersArr = []
      this.qrCodeValues.forEach((x, i) => {
        let obj = {
          order_id: null,
          customer_name: null,
          phone: null,
          customer_id: null,
          the_order_id: null,
          warehouse_id: null,
          transportation_type: null,
          is_ship_only: null
        }
        x.forEach((y, j) => {
          if (j === 0) {
            obj.order_id = y
          } else if (j === 1) {
            obj.customer_name = y
          } else if (j === 2) {
            obj.phone = y
          } else if (j === 3) {
            customerIds.push(y)
            obj.customer_id = y
          } else if (j === 4) {
            obj.the_order_id = y
          } else if (j === 8) {
            obj.warehouse_id = y
          } else if (j === 9) {
            obj.transportation_type = y
          } else if (j === 10) {
            obj.is_ship_only = y
          }
        })
        ordersArr.push(obj)
      })

      if (this.checkDiff(customerIds)) {
        swal({
          text: 'You selected different customers',
          icon: 'warning',
          dangerMode: true,
        })

        return
      }

      this.generateInvoiceData = {
        volume: 0,
        delivery_price: 0,
        customer_id: ordersArr[0].customer_id,
        customer_name: ordersArr[0].customer_name,
        warehouse_id: ordersArr[0].warehouse_id,
        transportation_type: ordersArr[0].transportation_type,
        is_ship_only: ordersArr[0].is_ship_only,
        phone: ordersArr[0].phone,
        orders: ordersArr,
      }

      this.orderInvoiceModal = true
    },

    generateInvoiceCustomer(id) {
      const customer = this.customersList.find((x) => x.value === id)
      this.generateInvoiceData = {
        customer_id: customer.value,
        customer_name: customer.text,
        phone: customer.phone,
        orders: [],
      }

      this.orderInvoiceModal = true
    },

    openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true,
        })
      } else {
        this.generateQrCodeModal = true
      }
    },

    closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false
      this.qrCodeValues = []
    },

    generateQrCode() {
      this.closeGenerateQrCodeModal()
    },

    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    prepareToPrint() {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.prepareToPrintUrl, {
          params: this.orderID,
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          let data = []
          data = response.data.data
          this.printData = []
          this.printData = data
        })
      this.modal('prepare_modal')
    },

    getOrderID(orders) {
      this.orderID.orders_id = []
      for (let i = 0; i < orders.length; i++) {
        this.orderID.orders_id[i] = orders[i].order_id
      }
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getOrderID(this.apiResults)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    sendToExport() {
      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName

      // Build URL parameters from current table state
      const params = new URLSearchParams({
        searchedOneCol: this.tableData.searchOneCol || '',
        searchedOneVal: this.tableData.searchOneVal || '',
        column: this.tableData.column || 'updated_at',
        sortDir: this.tableData.sortDir || 'desc',
        searchValue: this.tableData.search || '',
        from_date: this.tableData.from_date || '',
        to_date: this.tableData.to_date || '',
        warehouses: localStorage.getItem('warehouse_id_fk') || '',
        per_page: this.tableData.per_page || 10,
        branches_id: this.tableData.branches_id || ''
      })

      window.location.replace(fullHostName + '/api/delivered-to-erbil-export?' + params.toString())
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    sendAllToUser() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true,
        })

        return
      }
      let customerIds = []
      let orderIds = []
      this.qrCodeValues.forEach((x, i) => {
        x.forEach((y, j) => {
          if (j === 0) {
            orderIds.push(y)
          } else if (j === 3) {
            customerIds.push(y)
          }
        })
      })

      if (this.checkDiff(customerIds)) {
        swal({
          text: 'You selected different customers',
          icon: 'warning',
          dangerMode: true,
        })

        return
      }

      for (let i = 0; i < orderIds.length; i++) {
        const order = this.apiResults.find((x) => x.order_id === orderIds[i])

        if (Number(order.internal_shipping_handling) < 1 && !order.order_invoice_id_fk) {
          swal('Error', `Order ${order.theOrderID} does not have shipping price`, 'error')
          return
        }
      }

      const data = this.apiResults.find((x) => x.user_id === customerIds[0])

      if (Number(data.credit) < 0) {
        swal({
          title: 'Warning',
          text: `This customer (${data.full_name}) has loan and must pay at least $${Number(data.credit) * -1
            }`,
          icon: 'warning',
          buttons: ['Cancel', 'Skip'],
        }).then((confirm) => {
          if (confirm) {
            let token = localStorage.getItem('access_token')

            axios
              .put(
                'api/user_delivering_multiple',
                { orders: orderIds },
                {
                  headers: { Authorization: 'Bearer ' + token },
                }
              )
              .then(() => {
                this.getResults()
                swal({
                  title: 'Done',
                  text: '',
                  icon: 'success',
                  timer: 1000,
                  buttons: false,
                })
              })
              .catch((err) => {
                swal('Warning', err.response.data.message, 'error')
              })
          }
        })

        return
      }

      swal({
        title: 'Are you sure?',
        text: 'Once sent, you will not be able to return these order to this step!',
        icon: 'warning',
        buttons: true,
      }).then((confirm) => {
        if (confirm) {
          let token = localStorage.getItem('access_token')

          axios
            .put(
              'api/user_delivering_multiple',
              { orders: orderIds },
              {
                headers: { Authorization: 'Bearer ' + token },
              }
            )
            .then(() => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1000,
                buttons: false,
              })
            })
            .catch((err) => {
              swal('Warning', err.response.data.message, 'error')
            })
        }
      })
    },

    openSendToUserModal() {
      this.sendToUserModal = true
    },

    closeSendToUserModal() {
      this.sendToUserModal = false
      this.sendToUserData.order_id = ''
    },

    sendToUser() {
      let token = localStorage.getItem('access_token')

      axios
        .get(`api/get_order_detail/${this.sendToUserData.order_id}`, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          if (
            Number(response.data.data.internal_shipping_handling) < 1 &&
            !response.data.data.order_invoice_id_fk
          ) {
            swal(
              'Error',
              `This order #${response.data.data.theOrderID} does not have shipping price`,
              'error'
            )
            return
          }

          if (response.data.data.customer.credit < 0) {
            swal(
              'Error',
              `This customer (${response.data.data.customer.full_name
              }) has loan and must pay at least $${response.data.data.customer.credit * -1}`,
              'error'
            )
            return
          }

          axios
            .put(this.archiveOrderUrl + '/' + this.sendToUserData.order_id, '', {
              headers: { Authorization: 'Bearer ' + token },
            })
            .then((response) => {
              this.sendToUserData.order_id = ''
              this.getResults()
            })
            .catch((error) => {
              this.sendToUserData.order_id = ''
              swal('Error', `${error.response.data.message}`, 'error')
            })
        })
    },

    returnToPurchase(id) {
      swal({
        title: 'Are you sure?',
        text: 'You really want to return this order to Purchased section?',
        icon: 'warning',
        buttons: true,
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.returnToPurchaseUrl + id + '/return_to_purchase', '', {
              headers: { Authorization: 'Bearer ' + token },
            })
            .then((response) => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false,
              })
            })
            .catch((error) => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    deliverToUser(data) {
      if (Number(data.internal_shipping_handling) < 1 && !data.order_invoice_id_fk) {
        swal('Error', `This order does not have shipping price`, 'error')
        return
      }

      if (data.credit < 0) {
        swal({
          title: 'Warning',
          text: `This customer (${data.full_name}) has loan and must pay at least $${data.credit * -1
            }`,
          icon: 'warning',
          buttons: ['Cancel', 'Skip'],
        }).then((confirm) => {
          if (confirm) {
            let token = localStorage.getItem('access_token')
            axios
              .put(this.archiveOrderUrl + '/' + data.order_id, '', {
                headers: { Authorization: 'Bearer ' + token },
              })
              .then(() => {
                this.getResults()
                swal({
                  title: 'Done',
                  text: '',
                  icon: 'success',
                  timer: 1000,
                  buttons: false,
                })
              })
              .catch((error) => {
                swal('Error', `${error.response.data.message}`, 'error')
              })
          }
        })
        return
      }

      swal({
        title: 'Are you sure?',
        text: 'Once sent, you will not be able to return this order to this step!',
        icon: 'warning',
        buttons: true,
      }).then((accept) => {
        if (accept) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.archiveOrderUrl + '/' + data.order_id, '', {
              headers: { Authorization: 'Bearer ' + token },
            })
            .then((response) => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false,
              })
            })
            .catch((error) => {
              swal('Error', `${error.response.data.message}`, 'error')
            })
        }
      })
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },
  },
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.ship-only-label {
  display: inline-block;
  padding: 2px 8px;
  border: 2px solid #333;
  border-radius: 5px;
  font-weight: bold;
  font-size: 0.9em;
  color:green;
  border-color: green ;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/branchDeliveredOrder.vue